module.exports = __webpack_public_path__ + "static/img/introduce_framework.59a08b43.png";